export function articleSlider() {
  let initializedClassName = "initialized";

  $(".article-slider").each(function () {
    let slider = $(this);

    if (!slider.hasClass(initializedClassName)) {
      let items = slider.find(".article-item");

      if (items.length > 1) {
        slider.addClass(initializedClassName).slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          dots: true,
          arrows: false,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                arrows: true,
              },
            },
          ],
        });
      }
    }
  });
}

window.articleSlider = articleSlider;



// WEBPACK FOOTER //
// ./assets/js/modules/articleSlider.js